// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xOcpmhknaZiOwaCayjQ6 {
    background-color: var(--color-primary-white);
    border-radius: 12px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
    max-width: 28rem;
    padding: 1rem 1.5rem 0.75rem 1.5rem;
    box-sizing: border-box;
    transition: box-shadow 0.2s ease, border-color 0.2s ease;
    border: 1px solid transparent;
}

.xOcpmhknaZiOwaCayjQ6 p,
.xOcpmhknaZiOwaCayjQ6 .uZtfqW2SaHEBH13HCqb3 {
    color: var(--color-primary-black) !important;
    -webkit-text-fill-color: var(--color-primary-black) !important;
}

.xOcpmhknaZiOwaCayjQ6.Xl1TL4h2m4unUFu7grlw,
.xOcpmhknaZiOwaCayjQ6.BZGodSFs9LM632yegMyQ {
    box-shadow: none;
    border: 1px solid #dddddd;
}`, "",{"version":3,"sources":["webpack://./src/components/PersonalCodeWrapper/PersonalCodeWrapper.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mCAAmC;IACnC,sBAAsB;IACtB,wDAAwD;IACxD,6BAA6B;AACjC;;AAEA;;IAEI,4CAA4C;IAC5C,8DAA8D;AAClE;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":[".personal-code-box {\n    background-color: var(--color-primary-white);\n    border-radius: 12px;\n    margin: 0 auto;\n    text-align: center;\n    width: 100%;\n    max-width: 28rem;\n    padding: 1rem 1.5rem 0.75rem 1.5rem;\n    box-sizing: border-box;\n    transition: box-shadow 0.2s ease, border-color 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.personal-code-box p,\n.personal-code-box .mui-typography-root {\n    color: var(--color-primary-black) !important;\n    -webkit-text-fill-color: var(--color-primary-black) !important;\n}\n\n.personal-code-box.active,\n.personal-code-box.inactive {\n    box-shadow: none;\n    border: 1px solid #dddddd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"personalCodeBox": `xOcpmhknaZiOwaCayjQ6`,
	"muiTypographyRoot": `uZtfqW2SaHEBH13HCqb3`,
	"active": `Xl1TL4h2m4unUFu7grlw`,
	"inactive": `BZGodSFs9LM632yegMyQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
